import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Button,
} from '@mui/material';

interface DriveShareDialogProps {
  open: boolean;
  onClose: () => void;
  onOpenInDrive: () => void;
  fileUrl?: string;
}

const DriveShareDialog: React.FC<DriveShareDialogProps> = ({
  open,
  onClose,
  onOpenInDrive,
  fileUrl
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Share Google Drive File</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          This file needs to be shared in Google Drive for others to access it.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Due to Google Drive security restrictions, the app cannot automatically share files. Please share it manually:
        </Typography>
        <Box component="ol" sx={{ pl: 3, mb: 2 }}>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            Click "Open in Google Drive" below
          </Typography>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            Click the "Share" button in Google Drive
          </Typography>
          <Typography component="li" variant="body2" sx={{ mb: 1 }}>
            Make it accessible to "Anyone with the link"
          </Typography>
          <Typography component="li" variant="body2">
            Then share the Auditio link (will be copied when you click below)
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', mt: 2 }}>
          <Button onClick={onClose}>
            Cancel
          </Button>
          {fileUrl && (
            <Button
              variant="contained"
              onClick={onOpenInDrive}
            >
              Open in Google Drive
            </Button>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DriveShareDialog;


